module.exports = __webpack_public_path__ + "static/img/WeiMoKe.86fb9f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/coopera/images/phone/WeiMoKe.png
// module id = LA0B
// module chunks = 1